import MagicLink from './MagicLink.page';

export default MagicLink;
